<template>
    <job-cta-list-section
        class="job-categories-section-module"
        :title="attributes.jobCategories_title"
        :description="attributes.jobCategories_description"
        :all-jobs-link="attributes.all_jobs_link"
        :all-jobs-text="attributes.all_jobs_text"
        :job-ctas="jobCategories"
        :show-navigation-buttons="attributes.jobCategories_show_navigation_buttons"
    />
</template>

<script>
    import JobCtaListSection from '../../../organisms/JobCtaListSection/JobCtaListSection';
    import formatMediaObject from '../../../../utils/formatters/format-media-object';

    export default {
        name: 'job-categories-section-module',

        components: { JobCtaListSection },

        props: {
            attributes: {
                type: Object,
                default: () => ({}),
            },
        },

        computed: {
            /**
             * Format job categories.
             *
             * @returns {Array}
             */
            jobCategories() {
                return (this.attributes.job_categories || []).map((category) => {
                    return {
                        title: category.title,
                        text: category.description,
                        buttonText: category.apply_now_button_text,
                        buttonLink: category.apply_now_button_link,
                        image: formatMediaObject.call(this, category.image),
                    };
                });
            },
        },
    };
</script>
